/** Demo-only addon — demoLogin function. Imported by demo session.tsx. */

import type { DomainErrorBody, LoginResponse } from './types';
import { ApiError, setTokens } from './client';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
const WEBSITE_SESSION_KEY = 'konnextions-booking-session';

function websiteAccessToken(): string | null {
  try {
    const session = JSON.parse(sessionStorage.getItem(WEBSITE_SESSION_KEY) || 'null');
    if (!session?.access_token || session.expires_at * 1000 <= Date.now()) return null;
    return session.access_token;
  } catch {
    return null;
  }
}

export async function demoLogin(role: string): Promise<LoginResponse> {
  const response = await fetch(`${BASE}/demo/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${websiteAccessToken() ?? ''}`,
    },
    body: JSON.stringify({ role }),
  });
  const text = await response.text();
  let body: unknown = null;
  try { body = JSON.parse(text); } catch {}
  if (!response.ok) {
    throw new ApiError(response.status, body as DomainErrorBody | null, 'Demo login failed');
  }
  const parsed = body as LoginResponse;
  setTokens({ accessToken: parsed.access_token, refreshToken: parsed.refresh_token });
  return parsed;
}
